import { Loader } from "@itandi/itandi-bb-ui/Loader";
import { Page as Component } from "~/components/specifics/vendors/settings/Page";
import { useSessions } from "~/hooks/vendors/useSessions";

export function Page() {
	const { data: session, isLoading } = useSessions().index();

	if (isLoading || session === null) {
		return <Loader />;
	}

	return <Component session={session} />;
}
